
import WDElement from '../wd-element'

export class WDFormBasic extends WDElement
{

	/** convenience methods **/
	#config = {};
	#label = null;
	#input = null;
	#prefix = null;
	#suffix = null;
	#inputGroup = null;

	constructor(input, config)
	{
		super();
		if (config) Object.assign(this.#config, config);

		this.#input = input;
		this.append(input);

		/** now setup the attributes and properties we can handle at init time **/
		this.addAttributes();
		this.addProperties();

		/** add some passed event handlers if in the config **/
		for (let key in this.#config) 
		{
			if (key.indexOf('on') == '0') 
			{
				let evt = key.replace('on', '').toLowerCase();
				this.#input.addEventListener(evt, this.#config[key]);
			}
		}

		//add validation handler if passed
		if (this.#config.required) this.addFeedback();

		return this;
	};

	//
	get config() { return this.#config; };
	set config(val) { this.#config = val; };

	get input() { return this.#input; };
	get name() { return this.config.name; };
	get type() { return this.config.type; };
	get form() { return this.closest('.wd-form'); };

	hide()
	{
		this.classList.add('is-hidden');
	};

	show()
	{
		this.classList.remove('is-hidden');
	};

	get isHidden()
	{
		this.classList.contains('is-hidden');
	}

	get label()
	{
		if (!this.#label)
		{
			this.#label = wdc(`<label class="form-label" for="${this.name()}"/>`);
			this.prepend(this.#label);
		}

		return this.#label;
	};

	get prefix() 
	{
		if (!this.#prefix)
		{
			this.#prefix = wdc('<span class="input-group-text wd-input-group-prefix"/>');
			this.inputGroup.prepend(this.#prefix);
		}
		return this.#prefix;
	};

	get suffix() 
	{
		if (!this.#suffix)
		{
			this.#suffix = wdc('<span class="input-group-text wd-input-group-suffix"/>');
			this.inputGroup.append(this.#suffix);
		}

		return this.#suffix;

	};

	get inputGroup()
	{
		if (!this.#inputGroup)
		{
			//create a group and put our form in it
			this.#inputGroup = wdc('<div class="input-group"/>');
			this.#inputGroup.append(this.#input);

			if (this.#label)
			{
				this.#label.after(this.#inputGroup);
			}
			else
			{
				this.prepend(this.#inputGroup);
			}
		}

		return this.#inputGroup;
	};

	getAttribute(key) { return this.#input.getAttribute(key); };
	setAttribute(key,val) { return this.#input.setAttribute(key,val); };

	addProperties()
	{
		let keys = ['disabled', 'checked', 'required'];

		keys.forEach(key =>
		{
			if (this.#config[key] !== undefined) this[key] = this.#config[key];
		});

	};

	addAttributes()
	{
		const keys = [
				'id', 'name', 'readonly', 'placeholder', 'maxlength', 'autocomplete', 'autocorrect', 
				'autocapitalize', 'spellcheck', 'min', 'max', 'step', 'list',
				'pattern','inputmode'
			];

		keys.forEach(key =>
		{
			if (this.#config[key]) this.setAttribute(key, this.#config[key]);
		});

	};


	get readonly() { return this.#input.readOnly; };
	set readonly(val) { 
		this.#input.readOnly = val; 

		//I don't want to be able to tab to readonly items
		if (val == true) this.#input.tabIndex = -1;
		else delete this.#input.tabIndex;

	};
	get disabled() { return this.#input.disabled; };
	set disabled(val) { this.#input.disabled = val; };
	get required() { return this.#input.required; };
	set required(val) { this.#input.required = val; };

	/**  
	  adds feedback messages to the form if passed
	  */
	addFeedback()
	{
		this.inputGroup;

		if (this.#config.valid_msg)   
		{
			const vf = wdc(`<div class="valid-feedback">${this.#config.valid_msg}</div>`);
			this.inputGroup.append(vf);
		}

		if (this.#config.invalid_msg)
		{
			const ivf = wdc(`<div class="invalid-feedback">${this.#config.invalid_msg}</div>`);
			this.inputGroup.append(ivf);
		}
	};

	reset() { this.value = null; };

	get value() { return this.#input.value; };
	set value(val)
	{
		this.#input.value = val;
		this.trigger('value:set');
		//this.trigger('change');	//will need to be called manually
	};

	markCleanup()
	{
		this.classList.remove('is-valid', 'is-invalid', 'has-feedback');
		if (this.#suffix) 
		{
			this.#suffix.remove()
			this.#suffix = null;
		}
	};

	markValid(addSuffix) { return this.markSuccess(addSuffix); };
	markInvalid(addSuffix) { return this.markError(addSuffix); };

	markError(addSuffix)
	{
		this.markCleanup();
		this.classList.add('is-invalid');

		if (addSuffix)
		{
			const icon = wdc('<span class="fa-solid fa-exclamation"/>');
			this.suffix.classList.add('form-control-feedback');
			this.suffix.append(icon);

			const fb = this.querySelector('.invalid-feedback');
			if (fb) fb.before(this.suffix());
		}
	};

	markSuccess(addSuffix)
	{
		this.markCleanup();
		this.classList.add('is-valid');

		if (addSuffix)
		{
			const icon = wdc('<span class="fa-solid fa-check"/>');
			this.suffix.classList.add('form-control-feedback');
			this.suffix.append(icon);

			const fb = this.querySelector('.valid-feedback');
			if (fb) fb.before(this.suffix());

		}
	};

};

customElements.define('wd-form-basic', WDFormBasic);
